/*
 * SPW: 商品ページで Shopify Inbox のチャットボタンが購入ボタン（カートに入れる／Shopで購入）と
 * 重なっている間だけ、チャットボタンを購入ボタンの上まで持ち上げる。 2026-10-31
 * 重ならない位置では元の位置（右下）に戻る。チャット本体（開いた後の画面）には触らない。
 */
(function () {
  var GAP = 12;      // 購入ボタンとのすき間(px)
  var MIN_TOP = 96;  // これより上には上げない（ヘッダーとの干渉防止）
  var host = null, nudge = null, current = 0, hidden = false, ticking = false;

  function buyButtons() {
    var form = document.querySelector('main product-form') ||
               document.querySelector('main form[action*="/cart/add"]');
    if (!form) return [];
    var list = form.querySelectorAll(
      'button[name="add"], button[type="submit"], shopify-accelerated-checkout, ' +
      '.shopify-payment-button, more-payment-options-link'
    );
    return Array.prototype.filter.call(list, function (el) {
      return el.offsetWidth > 0 && el.offsetHeight > 0;
    });
  }

  function area(els) {
    var a = { top: Infinity, bottom: -Infinity, left: Infinity, right: -Infinity };
    els.forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (!r.height) return;
      a.top = Math.min(a.top, r.top);
      a.bottom = Math.max(a.bottom, r.bottom);
      a.left = Math.min(a.left, r.left);
      a.right = Math.max(a.right, r.right);
    });
    return a.top === Infinity ? null : a;
  }

  // チャットのボタンは shadow DOM の中（読み込み状態によっては二重の shadow DOM の中）にあるので、たどって探す
  function findIn(root, depth) {
    if (!root || depth > 4) return null;
    var el = root.querySelector('.activator-nudge');
    if (el) return el;
    var all = root.querySelectorAll('*');
    for (var i = 0; i < all.length; i++) {
      if (all[i].shadowRoot) {
        var found = findIn(all[i].shadowRoot, depth + 1);
        if (found) return found;
      }
    }
    return null;
  }

  function setup() {
    host = document.querySelector('shopify-chat');
    if (!host || !host.shadowRoot) return false;
    nudge = findIn(host.shadowRoot, 0);
    if (!nudge) return false;
    var root = nudge.getRootNode();
    if (root && root.getElementById && !root.getElementById('spw-chat-lift')) {
      var s = document.createElement('style');
      s.id = 'spw-chat-lift';
      s.textContent = '.activator-nudge{transition:margin-bottom .25s ease;}';
      root.appendChild(s);
    }
    return true;
  }

  // アプリ側のCSSが translate / opacity を上書きするため、margin-bottom と visibility で動かす
  function apply(lift, hide) {
    if (lift) nudge.style.setProperty('margin-bottom', (-lift) + 'px', 'important');
    else nudge.style.removeProperty('margin-bottom');
    if (hide) nudge.style.setProperty('visibility', 'hidden', 'important');
    else nudge.style.removeProperty('visibility');
    hidden = hide;
  }

  function update() {
    ticking = false;
    // チャットを開閉するとボタンが作り直されるので、毎回探し直し、別物なら状態をリセット
    var prev = nudge;
    if (!setup()) return;
    if (nudge !== prev) { current = 0; hidden = false; }
    if (!nudge.offsetHeight) return;
    // 動かす前の本来の位置（アニメーション途中の値に引っぱられないよう、bottom の指定値から計算）
    var r = nudge.getBoundingClientRect();
    var hostRect = host.getBoundingClientRect();
    var bottomPx = parseFloat(getComputedStyle(nudge).bottom) || 0;
    var baseBottom = hostRect.bottom - bottomPx;
    var baseTop = baseBottom - r.height;
    var a = area(buyButtons());
    var lift = 0, hide = false;

    if (a && a.top < baseBottom + GAP && a.bottom > baseTop - GAP &&
        a.left < r.right && a.right > r.left) {
      lift = Math.round(a.top - GAP - baseBottom);
      if (baseTop + lift < MIN_TOP) { lift = 0; hide = true; }
    }
    if (lift !== current || hide !== hidden) {
      current = lift;
      apply(lift, hide);
    }
  }

  function schedule() {
    if (ticking) return;
    ticking = true;
    setTimeout(update, 50); // rAF は一部の環境で間引かれるため setTimeout で間引き実行
  }

  // スクロールが止まった直後にもう一度合わせる（慣性スクロールの最終位置対策）
  var settle = null;
  function scheduleSettled() {
    schedule();
    clearTimeout(settle);
    settle = setTimeout(update, 200);
  }

  window.addEventListener('scroll', scheduleSettled, { passive: true });
  window.addEventListener('resize', scheduleSettled);

  // チャットは遅れて読み込まれる／ページ移動後も開いたままのことがあるので、
  // チャット本体が見つかったら1秒ごとに位置を確認し続ける（ボタンが出た時点で効く）
  var tries = 0;
  var timer = setInterval(function () {
    tries++;
    if (document.querySelector('shopify-chat')) {
      clearInterval(timer);
      schedule();
      setInterval(schedule, 1000);
    }
    else if (tries > 60) { clearInterval(timer); }
  }, 500);
})();
